export default __webpack_public_path__ + "static/046-ba3d58bef7709c3e58fc6918da69ab27.jpg";